import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
var _class;
import React from "react";
import intl from "../../utils/intl";
import { BlockContainer } from "./index.style";
import SectionTitle from "../_components/SectionTitle";
import ConfigItem from "../_components/ConfigItem";
import withFormOperate from "../_components/withFormOperate";
import { getMemoizedAssets, getStaticGif } from "./util";
import MotionTitle from "../_components/MotionTitle";
var FormInputConfig = withFormOperate(_class = /*#__PURE__*/function (_React$Component) {
  _inherits(FormInputConfig, _React$Component);
  var _super = _createSuper(FormInputConfig);
  function FormInputConfig() {
    var _this;
    _classCallCheck(this, FormInputConfig);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _this.memoizedInput = getMemoizedAssets(_this.props.styleCounts.input, "input");
    _this.memoizedEmailInput = getMemoizedAssets(_this.props.styleCounts.input, "input/email-input");
    _this.memoizedPasswordInput = getMemoizedAssets(_this.props.styleCounts.input, "input/password-input");
    _this.memoizedNumberInput = getMemoizedAssets(_this.props.styleCounts.input, "input/number-input");
    _this.memoizedLov = getMemoizedAssets(_this.props.styleCounts.input, "input/Lov");
    _this.memoizedTextarea = getMemoizedAssets(_this.props.styleCounts.input, "input/text-input");
    _this.getRequiredColor = getMemoizedAssets(_this.props.styleCounts.formColor, "input/required-color");
    _this.getMotions1 = getStaticGif(_this.props.styleCounts.inputMotion, "input/motions", "png", "1");
    _this.getMotions2 = getStaticGif(_this.props.styleCounts.inputMotion, "input/motions", "png", "2");
    _this.getMoneyField = getMemoizedAssets(_this.props.styleCounts.input, "input/money", "svg");
    return _this;
  }
  _createClass(FormInputConfig, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
        value = _this$props.value,
        schema = _this$props.schema,
        handleChange = _this$props.handleChange; // const disabledArr = [0, 1, 2, 3, 4].map(v => v !== value.style);

      var textInputs = this.memoizedInput(schema);
      var numberInputs = this.memoizedNumberInput(schema);
      var emailInputs = this.memoizedEmailInput(schema);
      var passwordInputs = this.memoizedPasswordInput(schema);
      var textareaInputs = this.memoizedTextarea(schema);
      var lovInputs = this.memoizedLov(schema);
      return /*#__PURE__*/React.createElement(BlockContainer, {
        id: "inputs-config"
      }, /*#__PURE__*/React.createElement(SectionTitle, {
        titleTail: "Input",
        title: "\u8F93\u5165",
        style: {
          marginTop: 24
        }
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "input",
        title: intl.get("hzero.hzeroTheme.page.textField").d("文本输入框"),
        simple: true,
        items: textInputs,
        defaultSelected: value.input,
        onChange: handleChange("input")
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "money",
        title: intl.get("hzero.hzeroTheme.page.moneyField").d("金额输入框"),
        simple: true,
        items: this.getMoneyField(schema),
        defaultSelected: value.input,
        onChange: handleChange("input")
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "email",
        title: intl.get("hzero.hzeroTheme.page.emailField").d("邮件输入框"),
        simple: true,
        items: emailInputs,
        defaultSelected: value.input,
        onChange: handleChange("input")
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "password",
        cols: 2,
        title: intl.get("hzero.hzeroTheme.page.password").d("密码输入框"),
        items: passwordInputs,
        defaultSelected: value.input,
        onChange: handleChange("input")
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "number",
        simple: true,
        title: intl.get("hzero.hzeroTheme.page.numberField").d("数字输入框"),
        className: "number",
        items: numberInputs,
        onChange: handleChange("input") // disabledItems={disabledArr}
        ,

        defaultSelected: value.input
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "lov",
        simple: true,
        title: intl.get("hzero.hzeroTheme.page.lov").d("弹出选择框（Lov）") // title="弹出选择框(LOV)"
        ,

        className: "number",
        items: lovInputs,
        onChange: handleChange("input"),
        defaultSelected: value.input
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "textarea",
        title: intl.get("hzero.hzeroTheme.page.textarea").d("文本域输入框"),
        simple: true,
        items: textareaInputs,
        onChange: handleChange("input") // disabledItems={disabledArr}
        ,

        defaultSelected: value.input
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "formColor",
        className: "motion-config" // title="必填框颜色（系统中所有必填色统一，包含选择框等）"
        ,

        title: intl.get("hzero.hzeroTheme.page.requiredColorMsg").d("必填框颜色（系统中所有必填色统一，包含选择框等）"),
        items: this.getRequiredColor(schema),
        defaultSelected: value.formColor,
        onChange: handleChange("formColor") // onChange={handleChange("requiredStyle")}
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "inputMotion",
        className: "motion-config",
        title: /*#__PURE__*/React.createElement(MotionTitle, {
          text: intl.get("hzero.hzeroTheme.page.animation").d("动效")
        }),
        items: this.getMotions1(schema),
        defaultSelected: value.inputMotion,
        onChange: handleChange("inputMotion")
      }), /*#__PURE__*/React.createElement(ConfigItem, {
        name: "inputMotion",
        className: "motion-config",
        title: /*#__PURE__*/React.createElement(MotionTitle, {
          text: intl.get("hzero.hzeroTheme.page.animation").d("动效")
        }),
        items: this.getMotions2(schema),
        defaultSelected: value.inputMotion,
        onChange: handleChange("inputMotion")
      }));
    }
  }]);
  return FormInputConfig;
}(React.Component)) || _class;
export { FormInputConfig as default };